/**
 * This file is auto-generated from BenefitsSection.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const benefitsTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Benefits that go beyond a traditional doctor visit';
        case 'pl':
            return 'Jak wspieramy naszych pacjentów';
    }
};

export const benefitsNoPaperworkTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'No unnecessary paperwork';
        case 'pl':
            return 'Brak zbędnych formalności';
    }
};

export const benefitsNoPaperworkDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Skip long forms and waiting rooms. A short description of your symptoms is enough for the doctor to act.';
        case 'pl':
            return 'Ty opisujesz swoje objawy i odpowiadasz na kilka prostych pytań, a nasz system automatycznie przygotowuje pełny raport dla lekarza.';
    }
};

export const benefitsConsultFromHomeTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Consult from home';
        case 'pl':
            return 'Kontakt z lekarzem bez wychodzenia z domu';
    }
};

export const benefitsConsultFromHomeDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'The entire process is online – no travel, no waiting in clinics.';
        case 'pl':
            return 'Nie musisz nigdzie dzwonić, ani stać w kolejkach. Potrzebujesz tylko telefonu lub komputera z dostępem do internetu.';
    }
};

export const benefitsSameDayHelpTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Same-day help';
        case 'pl':
            return 'Pomoc tego samego dnia';
    }
};

export const benefitsSameDayHelpDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return "In most cases you'll receive your treatment plan the very same day.";
        case 'pl':
            return 'Dzięki udziałowi AI w procesie rejestracji, maksymalnie w 24 godziny otrzymasz wsparcie specjalisty i plan leczenia. Jeśli rozpoczniesz konsultację przed południem, to odbędzie się ona tego samego dnia.';
    }
};

export const benefitsNoHiddenCostsTitle: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'No hidden costs';
        case 'pl':
            return 'Brak ukrytych kosztów';
    }
};

export const benefitsNoHiddenCostsDescription: Translation<{ price: unknown }> = (lang, params) => {
    switch (lang) {
        case 'en':
            return [
                'At Healed, a consultation costs ',
                params.price,
                '. We do not charge extra for issuing prescriptions or sick notes. Remember, the doctor decides whether to issue prescriptions or sick notes.',
            ];
        case 'pl':
            return [
                'W Healed za konsultację zapłacisz ',
                params.price,
                '. Za wypisanie recepty i zwolnienia nie pobieramy dodatkowych opłat. Pamiętaj, że to lekarz decyduje o wystawieniu wszystkich niezbędnych dokumentów.',
            ];
    }
};

export const benefitsCtaHeading: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Feeling poorly? Get your diagnosis today.';
        case 'pl':
            return 'Źle się czujesz? Uzyskaj diagnozę już dziś.';
    }
};

export const benefitsCtaDescription: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Fill out a simple, automated survey of your symptoms. Then recieve your treatment plan from a physician.';
        case 'pl':
            return 'Wypełnij prostą ankietę dotyczącą objawów, a następnie otrzymaj plan leczenia od lekarza.';
    }
};
